@import '../../../../globals/main';

pn-line-shape {
  .pn-line-shape__container {
    display: flex;
  }

  .pn-line-shape__line {
    border-style: solid;
    border-width: 0.4rem;
    border-radius: 1.6rem;

    border-color: $blue400;
  }

  .pn-line-shape__dot {
    width: 0.8rem;
    border-style: solid;
    border-width: 0.4rem;
    border-radius: 1.6rem;
    height: 0.8rem;
    border-color: $blue400;
  }
}

pn-line-shape[slot='horizontal-line'] {
  .pn-line-shape__container {
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    gap: 0.8rem;
    padding: 2.4rem 0;
  }

  .pn-line-shape__line {
    height: 0.8rem;
    width: 100%;
  }
  .pn-line-shape__dot {
  }
}

pn-line-shape[slot='vertical-line'] {
  .pn-line-shape__container {
    height: 100%;
    flex-direction: column;
    gap: 0.8rem;
    padding: 0.8rem 0.5rem;
  }

  .pn-line-shape__line {
    height: 100%;
    width: 0.8rem;
  }
}
